import React from 'react'
import PropTypes from 'prop-types'

import Button from '../Button'
import ButtonLoader from '../ButtonLoader'

const SubmitButton = ({
  className,
  size = 'default',
  theme = 'primary',
  variant = 'default',
  submitLabel = 'Submit',
  submittingLabel = 'Submitting',
  isSubmitting,
  onClick,
  ...props
}) =>
  isSubmitting ? (
    <ButtonLoader theme={theme} variant={variant} className={className} label={submittingLabel} size={size} />
  ) : (
    <Button
      onClick={onClick}
      variant={variant}
      theme={theme}
      className={className}
      size={size}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      label={submitLabel}
      type="submit"
    />
  )

SubmitButton.propTypes = {
  submitLabel: PropTypes.string,
  submittingLabel: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'light', 'dark', 'tertiary', 'info']),
  size: PropTypes.oneOf(['', 'default', 'small', 'medium']),
  variant: PropTypes.oneOf(['', 'default', 'outlined', 'dashed']),
  onClick: PropTypes.func.isRequired,
  className: PropTypes.string,
  isSubmitting: PropTypes.bool,
}

export default SubmitButton
